<template>
    <div class="footer">
        <div class="container">
            <div class="footer-top">
                <h3>友情链接</h3>
                <div class="col-md-12 top-footer">
                    <ul>
                        <li v-for="item in itemList" v-if="item.status==1">
                            <a :href="item.url" target="_blank" :title="item.desc">{{item.title}}</a>
                            <span>{{item.desc}}</span>
                        </li>
                    </ul>
                </div>
                <div class="clearfix"></div>
            </div>
            <p> © 2017-2021 Git游戏 All rights reserved</p>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Footer',
  components: {},
  data() {
    return {
      itemList: []
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      var timeStamp = new Date().getTime()
      this.$http.get('static/data/friend_link.json' + '?' + timeStamp).then(res => {
        this.itemList = res.data
        //                        console.log(this.itemList);
      },
      res => {
        console.log('error')
      }
      )
    }
  }

}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue